/**
 * Example JavaScript singleton module
 */

var Header = (function($) {
  function initHeader() {
    $(".header-hamburger").click(function() {
      $("body").toggleClass("has-nav");
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".header").length) {
      return;
    }

    initHeader();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Header.init);
